<div class="container" [style.display]="modalIsShow?'block':'none'">
    <iframe id="iframePreview"></iframe>
    <a id="previewInNewTabLink" href="#" target="_blank"></a>
</div>